var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCashFlow64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cashflow64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramCashFlow64.ca2212a5",
    transform: "translate(9.000000, 14.548417)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(23.500000, 20.166667) scale(-1, 1) translate(-23.500000, -20.166667) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#4F4C4D",
    points: "0 38.3333333 47 38.3333333 47 40.3333333 0 40.3333333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00",
    x: 1,
    y: 0,
    width: 11,
    height: 39.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 19,
    y: 11.1944444,
    width: 11,
    height: 28.1388889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 36,
    y: 24.9722222,
    width: 11,
    height: 14.3611111
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCashFlow64);
export default __webpack_public_path__ + "static/media/pictogramCashFlow64.19da718775269f332cfe4b82b9925a84.svg";
export { ForwardRef as ReactComponent };